const clientId = process.env.REACT_APP_AZURE_CLIENT_ID;
const tenantId = process.env.REACT_APP_AZURE_TENANT_ID;
const scope: any = process.env.REACT_APP_AZURE_SCOPE;

const redirectUrl = (targetRedirectUri?: string) => {
  const redirectUri: any = targetRedirectUri;
  const authUrl =
    `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize` +
    `?client_id=${clientId}` +
    `&response_type=code` +
    `&scope=${encodeURIComponent(scope)}` +
    `&redirect_uri=${encodeURIComponent(redirectUri)}` +
    `&prompt=none`; // ← enables silent login if same session
  console.log("redirectUrl", authUrl);
  window.open(authUrl, "_blank", "noopener,noreferrer");
};

export default redirectUrl;
